import { syncStore$ } from "@/stores/sync.v2.store"
import { use$ } from "@legendapp/state/react"
import { useMemo } from "react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import advancedFormat from "dayjs/plugin/advancedFormat"
import { getAccountTrialStatus } from "@/lib/accountTrialState"

dayjs.extend(utc)
dayjs.extend(advancedFormat)

export function useModelAccount() {
  const isInTrial = use$(syncStore$.account.inTrial)
  const isTrialActivated = use$(syncStore$.account.trialActivated)
  const isTrialExpired = use$(syncStore$.account.trialExpired)
  const isTrialConsumed = use$(syncStore$.account.trialConsumed)
  const trialType = use$(syncStore$.userStatus.accountTrialType)
  const trialDaysRemaining = use$(syncStore$.account.trialDaysRemaining)
  const trialMinutesRemaining = use$(syncStore$.account.trialMinutesRemaining)
  const soloTrialMinutesRemaining = use$(syncStore$.account.soloTrialMinutesRemaining)
  const isSoloFree = use$(syncStore$.account.isSoloFree)
  const isSoloTrialConsumed = use$(syncStore$.account.soloTrialConsumed)
  const soloTrialCurrentPeriodResetDate = use$(syncStore$.account.soloTrialCurrentPeriodResetDate)
  const soloTrialCurrentPeriodResetFormatted = useMemo(() => {
    const convertedTime = dayjs.utc(soloTrialCurrentPeriodResetDate).local()
    return convertedTime.format("MMM Do")
  }, [soloTrialCurrentPeriodResetDate])

  const trialStatus = use$(() =>
    getAccountTrialStatus({
      trialActivated: isTrialActivated,
      inTrial: isInTrial,
      trialExpired: isTrialExpired,
      isSoloFree,
      soloTrialConsumed: isSoloTrialConsumed,
    })
  )

  return {
    isInTrial,
    isTrialActivated,
    isTrialExpired,
    isTrialConsumed,
    trialType,
    trialDaysRemaining,
    trialMinutesRemaining,
    soloTrialMinutesRemaining,
    isSoloFree,
    isSoloTrialConsumed,
    soloTrialCurrentPeriodResetDate: soloTrialCurrentPeriodResetFormatted,
    trialStatus,
  }
}
